import styled from 'styled-components';
import { RootPortal } from '../../../common/RootPortal';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { USED_TICKET_MODAL_CONSTANTS } from '../../../../constants/usedTicketModal';
import { UsedTicketModalProps } from '../UsedTicketModal';

export const UsedTicketModalPc = ({
  isVisibleCommon,
  commonCallback1,
  commonCallback2,
}: UsedTicketModalProps) => {
  const { getText } = useTextVariant(USED_TICKET_MODAL_CONSTANTS, false);

  return (
    <RootPortal>
      <ModalWrap $visible={isVisibleCommon}>
        <Dim />
        <ModalContent $visible={isVisibleCommon}>
          <Content>
            <ContentText>{getText('contentText')}</ContentText>
          </Content>

          <ButtonRowContainer>
            <CancelButton onClick={() => commonCallback2?.()}>
              {getText('cancelBtn') as string}
            </CancelButton>
            <UsedButton onClick={() => commonCallback1?.()}>
              {getText('confirmBtn') as string}
            </UsedButton>
          </ButtonRowContainer>
        </ModalContent>
      </ModalWrap>
    </RootPortal>
  );
};

const UsedButton = styled.button`
  width: 182px;
  height: 50px;
  border-radius: 25px;
  background: #5200d3;
  box-shadow:
    0 -1px 0 0 rgba(104, 104, 104, 0.3) inset,
    0 2px 0 0 rgba(0, 0, 0, 0.15),
    0 1px 1px 0 rgba(173, 166, 153, 0.5) inset;

  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 18px; /* 90% */
  letter-spacing: -1.2px;
  cursor: pointer;
`;
const CancelButton = styled.button`
  width: 140px;
  height: 50px;
  border-radius: 25px;
  border: 2px solid #454545;
  background: #201f1e;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.3);
  margin-right: 10px;

  color: #afaaaa;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 18px; /* 90% */
  letter-spacing: -1.2px;
  cursor: pointer;
`;

const ButtonRowContainer = styled.div`
  width: 100%;
  position: absolute;
  height: 74px;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 0px 0px 20px 20px;
  background: #222120;
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  width: 90%;
  max-width: 420px;
  max-height: 80%;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px;
  padding-bottom: 74px;
`;

const Content = styled.div`
  height: 156px;
  border-radius: 8px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px; /* 120% */
`;
